import styled from '@emotion/styled';

export const LightText = styled.p({
  fontWeight: 300,
  marginTop: 5,
  marginBottom: 5
});
